import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';

// Admin pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Calendar from './pages/Calendar';
import Appointments from './pages/Appointments';
import Quotes from './pages/Quotes';
import Jobs from './pages/Jobs';
import JobDetail from './pages/JobDetail';
import BusinessCosts from './pages/BusinessCosts';
import Reports from './pages/Reports';
import Clients from './pages/Clients';
import ClientDetail from './pages/ClientDetail';
import MapPage from './pages/Map';
import Drops from './pages/Drops';
import DropDetail from './pages/DropDetail';
import Gallery from './pages/Gallery';
import Content from './pages/Content';
import Services from './pages/Services';
import Availability from './pages/Availability';
import Team from './pages/Team';
import Settings from './pages/Settings';

// Public booking app
import BookingLayout from './components/BookingLayout/BookingLayout';
import BookingWizard from './pages/public/BookingWizard';
import ManageBooking from './pages/public/ManageBooking';
import QuoteView from './pages/public/QuoteView';
import QuoteRequest from './pages/public/QuoteRequest';

// Layout
import MainLayout from './components/Layout/MainLayout';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="loading-screen">
        <div className="loading-spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <Routes>
      {/* PUBLIC booking app — no auth, no admin chrome */}
      <Route element={<BookingLayout />}>
        <Route path="/book" element={<BookingWizard />} />
        <Route path="/book/:staffSlug" element={<BookingWizard />} />
        <Route path="/booking/:token" element={<ManageBooking />} />
        <Route path="/quote/:token" element={<QuoteView />} />
        <Route path="/get-a-quote" element={<QuoteRequest />} />
      </Route>

      {/* Admin auth */}
      <Route path="/login" element={<Login />} />

      {/* Admin app */}
      <Route path="/" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="calendar" element={<Calendar />} />
        <Route path="appointments" element={<Appointments />} />
        <Route path="quotes" element={<Quotes />} />
        <Route path="jobs" element={<Jobs />} />
        <Route path="jobs/:id" element={<JobDetail />} />
        <Route path="business-costs" element={<BusinessCosts />} />
        <Route path="reports" element={<Reports />} />
        <Route path="clients" element={<Clients />} />
        <Route path="clients/:id" element={<ClientDetail />} />
        <Route path="map" element={<MapPage />} />
        <Route path="drops" element={<Drops />} />
        <Route path="drops/:id" element={<DropDetail />} />
        <Route path="gallery" element={<Gallery />} />
        <Route path="content" element={<Content />} />
        <Route path="services" element={<Services />} />
        <Route path="availability" element={<Availability />} />
        <Route path="team" element={<Team />} />
        <Route path="settings" element={<Settings />} />
      </Route>

      {/* Public booking routes are added in the public-booking build phase. */}

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
